export const id = "fundraising";
function SectionFR() {
  return <></>;
}

export default SectionFR;
